/**
 * Created by Alex Aguilar on 7/26/2016.
 */
(function(){
    'use strict';

    var breadcrumb = {
        templateUrl: 'app/components/breadcrumb/breadcrumb.html',
        controller: breadcrumbController,
        controllerAs: 'vm',
        bindings:{
            menu: '@',
            option: '@',
            fa: '@'
        }
    };

    var acClock = {
        template: '<span class="bold">{{vm.clock}}</span>',
        controller: acClockController,
        controllerAs: 'vm'
    }

    angular
        .module('completeAir')
        .component('breadcrumb', breadcrumb)
        .component('acClock', acClock);

    breadcrumbController.$inject = ['$rootScope', 'Principal']
    acClockController.$inject = ['$interval'];

    function breadcrumbController($rootScope,Principal){
        var vm = this;
        vm.dateCurrent = new Date();
        vm.loginNames = '';

        vm.refresh = function(){
            vm.isLogin = Principal.isAuthenticated;
            if(vm.isLogin){
                vm.loginNames = $rootScope.loginNames;
                vm.loginInitials = $rootScope.loginInitials;
                return true;
            }
            return false;
        }
    }

    function acClockController($interval){
        var vm = this;
        timeClock();
        vm.clock = "";

        $interval(function(){
            timeClock();
        }, 1000)

        function timeClock (){

            var date = new Date();
            var hours = date.getHours();
            var minutes = date.getMinutes();
            var seconds = date.getSeconds();

            if (hours <= 9){
                hours = "0" + hours;
            }
            if (minutes <= 9){
                minutes = "0" + minutes;
            }
            if (seconds <= 9){
                seconds = "0" + seconds;
            }

            vm.clock = hours + ":" + minutes + ":" + seconds;
        }
    }

})();

